import * as pdfjsLib from "pdfjs-dist";
import type { TextItem } from "pdfjs-dist/types/src/display/api";
import type { ParsedFileData } from "../types";

const PDFJS_VERSION = pdfjsLib.version;

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${PDFJS_VERSION}/build/pdf.worker.min.mjs`;

const LINE_Y_TOLERANCE = 2;

function joinTextItems(items: TextItem[]): string {
  const nonEmpty = items.filter((item) => item.str.length > 0);
  if (nonEmpty.length === 0) return "";

  const parts: string[] = [nonEmpty[0].str];

  for (let i = 1; i < nonEmpty.length; i++) {
    const prev = nonEmpty[i - 1];
    const curr = nonEmpty[i];

    const yDiff = Math.abs(curr.transform[5] - prev.transform[5]);
    if (yDiff > LINE_Y_TOLERANCE) {
      parts.push(" ");
    } else {
      const prevEndX = prev.transform[4] + prev.width;
      const gap = curr.transform[4] - prevEndX;

      if (gap > 1 && !prev.str.endsWith(" ") && !curr.str.startsWith(" ")) {
        parts.push(" ");
      }
    }

    parts.push(curr.str);
  }

  return parts.join("");
}

export async function parsePdfFile(file: File): Promise<ParsedFileData> {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

  const textParts: string[] = [];

  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    const textItems = content.items.filter(
      (item): item is TextItem => "str" in item
    );
    textParts.push(joinTextItems(textItems));
  }

  const fullText = textParts.join(" ");

  return {
    fileName: file.name,
    fileFormat: "pdf",
    sheets: [
      {
        sheetName: "_pdf_text",
        cells: {
          A1: {
            cell: "A1",
            rawValue: fullText,
            formattedValue: fullText,
            sheetName: "_pdf_text",
          },
        },
      },
    ],
  };
}
